import { render, staticRenderFns } from "./addChange.vue?vue&type=template&id=5f228134&scoped=true&"
import script from "./addChange.vue?vue&type=script&lang=js&"
export * from "./addChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f228134",
  null
  
)

export default component.exports